import useLenis from "@/lib/useLenis";
import { EarlyAccessProvider } from "@/components/landing/EarlyAccessContext";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import Audience from "@/components/landing/Audience";
import Marquee from "@/components/landing/Marquee";
import Ecosystem from "@/components/landing/Ecosystem";
import EarlyAccessCTA from "@/components/landing/EarlyAccessCTA";
import Footer from "@/components/landing/Footer";
import { Toaster } from "sonner";

export default function Landing() {
  useLenis();
  return (
    <EarlyAccessProvider>
      <div className="grain relative min-h-screen bg-white" data-testid="landing-page">
        <Nav />
        <main>
          <Hero />
          <Manifesto />
          <Audience />
          <Marquee />
          <Ecosystem />
          <EarlyAccessCTA />
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </EarlyAccessProvider>
  );
}
